(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function(){
  var SEL='[data-tcs-upsell]';
  var timer;
  var agreed=false;
  function reload(){
    window.refreshCart();
    setTimeout(window.refreshCart,1600);
  }
  function restoreTerms(){
    var c=document.getElementById('AgreeToTosDrawer');
    if(c)c.checked=agreed;
  }
  function clearError(w){
    w.classList.remove('agree-to-terms--error');
    w.querySelector('.agree-to-terms__msg').hidden=true;
    w.querySelector('input').removeAttribute('aria-invalid');
  }
  function showError(w){
    var c=w.querySelector('input');
    w.classList.remove('agree-to-terms--error');
    void w.offsetWidth;
    w.classList.add('agree-to-terms--error');
    w.querySelector('.agree-to-terms__msg').hidden=false;
    c.setAttribute('aria-invalid','true');
    w.scrollIntoView({block:'center',behavior:'smooth'});
    setTimeout(function(){c.focus({preventScroll:true})},350);
  }
  window.handleAddToCart=function(body,count,headers,done){
    fetch('/cart/add.js',{method:'POST',headers:headers,body:body}).then(function(r){return r.json()}).then(function(d){if(!d.status)reload()}).catch(function(){}).finally(done);
  };
  document.addEventListener('change',function(e){
    var t=e.target;
    if(!t.closest)return;
    var s=t.closest('[data-tcs-upsell-select]');
    if(s){
      var item=s.closest('.tcs-cart-upsell__item');
      var opt=s.selectedOptions[0];
      item.querySelector('[data-tcs-upsell-price]').textContent=opt.dataset.price;
      var deal=item.querySelector('[data-tcs-deal]');
      if(deal)deal.hidden=!opt.dataset.deal;
      return;
    }
    if(t.id==='AgreeToTosDrawer'){
      agreed=t.checked;
      if(t.checked)clearError(t.closest('.agree-to-terms'));
    }
  });
  document.addEventListener('click',function(e){
    var t=e.target;
    if(!t.closest)return;
    if(t.closest('#CheckOut')){
      var c=document.getElementById('AgreeToTosDrawer');
      if(c&&!c.checked){
        e.preventDefault();
        e.stopPropagation();
        showError(c.closest('.agree-to-terms'));
      }
      return;
    }
    var nav=t.closest('[data-tcs-slide]');
    if(nav){
      var list=document.querySelector('[data-tcs-list]');
      if(list&&list.firstElementChild)list.scrollBy({left:Number(nav.dataset.tcsSlide)*(list.firstElementChild.offsetWidth+10),behavior:'smooth'});
      return;
    }
    var b=t.closest('[data-tcs-upsell-add]');
    if(!b)return;
    var id=Number(b.closest('.tcs-cart-upsell__item').querySelector('select').value);
    b.disabled=true;
    b.setAttribute('aria-busy','true');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})}).then(function(r){return r.json()}).then(function(d){if(!d.status)reload()}).finally(function(){b.disabled=false;b.removeAttribute('aria-busy')});
  },true);
  function refreshUpsell(){
    clearTimeout(timer);
    timer=setTimeout(function(){
      fetch('?section_id=cart-drawer').then(function(r){return r.text()}).then(function(html){
        var next=new DOMParser().parseFromString(html,'text/html').querySelector(SEL);
        var current=document.querySelector(SEL);
        if(next&&current)current.innerHTML=next.innerHTML;
      });
    },300);
  }
  function init(){
    var sub=document.getElementById('AjaxCartSubtotal');
    if(sub)new MutationObserver(function(){restoreTerms();refreshUpsell()}).observe(sub,{childList:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    new Splide('#testimonialSplide', {
      type   : 'loop',
      perPage: 4,
      arrows: false,
      gap: '20px',
      autoplay: false,
      pagination: false,
      breakpoints: {
        1024: { perPage: 2 },
        768: { perPage: 1, gap: '17px', focus: 'center' }
      }
    }).mount();
  });

  } catch(e) { console.error(e); }
})();
})();
